module.exports = __webpack_public_path__ + "static/media/BWS_2026_PDF.f6890cf0.pdf";